export default function()
{
    const self = this;

    self.init = () => {

        $( ".location-item" ).mouseenter(function() {
            if ($(this).data('location-id')) {
                let locationId = $(this).data('location-id');

                $( ".map-pointer-box .map-pointer" ).each(function( ) {
                    if ($( this ).data('location-id') === locationId) {
                        $( this ).fadeIn();
                    } else {
                        $( this ).hide();
                    }
                });
            }
        }).mouseleave(function() {
            $( ".map-pointer-box .map-pointer" ).each(function( ) {
                $( this ).fadeIn();
            });
        });
    };
}


// WEBPACK FOOTER //
// ./scripts/maps.js